module.exports = __webpack_public_path__ + "media/ai_assist.534c0e10.ogg";